import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import ServiceIcon from "@/components/ServiceIcon";

export default function ServicesGrid({ limit }) {
  const { services } = useSite();
  const list = limit ? services.slice(0, limit) : services;

  return (
    <section data-testid="services-grid" className="section-padding bg-[#f5f7fa] relative overflow-hidden">
      <div className="absolute inset-0 tech-grid opacity-50 pointer-events-none"></div>
      <div className="dc-container relative">
        <div className="max-w-3xl mb-14">
          <span className="text-xs font-semibold uppercase tracking-[0.25em] text-dc-primary">Nossos serviços</span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-dc-text mt-3 mb-5">
            Soluções completas em <span className="text-dc-primary">tecnologia corporativa</span>
          </h2>
          <p className="text-base md:text-lg text-slate-600 leading-relaxed">
            Da manutenção preventiva ao desenvolvimento de sistemas sob medida — entregamos infraestrutura sólida e software de alta performance.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {list.map((s, idx) => (
            <motion.div
              key={s.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.4, delay: (idx % 4) * 0.05 }}
              data-testid={`service-card-${s.id}`}
              className="group relative bg-white rounded-2xl p-7 border border-slate-100 shadow-[0_4px_20px_-4px_rgba(0,87,168,0.08)] hover:shadow-[0_18px_40px_-8px_rgba(0,87,168,0.18)] hover:-translate-y-1.5 hover:border-dc-primary/20 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-dc-primary/10 to-dc-accent/10 text-dc-primary flex items-center justify-center mb-5 group-hover:bg-dc-primary group-hover:text-white transition-all">
                <ServiceIcon name={s.icon} className="w-6 h-6" />
              </div>
              <h3 className="font-heading font-semibold text-lg text-dc-text mb-2.5 leading-snug">{s.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed mb-5 min-h-[60px]">{s.short_description}</p>
              <Link
                to="/orcamento"
                data-testid={`service-cta-${s.id}`}
                className="inline-flex items-center gap-1.5 text-sm font-semibold text-dc-primary group-hover:gap-2.5 transition-all"
              >
                Solicitar orçamento <ArrowRight className="w-4 h-4" />
              </Link>
              <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-dc-accent/10 to-transparent rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity"></div>
            </motion.div>
          ))}
        </div>

        {limit && services.length > limit && (
          <div className="text-center mt-12">
            <Link
              to="/servicos"
              data-testid="services-see-all"
              className="inline-flex items-center gap-2 bg-dc-primary hover:bg-dc-primary-hover text-white px-8 py-4 rounded-full font-semibold transition-all shadow-lg shadow-dc-primary/25 hover:-translate-y-0.5"
            >
              Ver todos os serviços <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}
